import { useEffect, useState } from 'react';

interface ICheckItem {
  text: string;
  required: boolean;
  guideText: string;
  termCd: string;
  path: string;
  subTextItem: any[];
  checked: boolean;
}

const useCheckBottomsheet = (
  checkList: ICheckItem[],
  activeCondition: 'all' | 'essential' | string = 'essential',
) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [list, setList] = useState<any>(checkList);

  useEffect(() => {
    setList(checkList);
  }, [checkList]);
  const open = () => {
    setIsOpen(true); //bottomSheet
  };
  const close = () => {
    setIsOpen(false);
  };

  const hasOnlyOptional = () => {
    return list.every((item: any) => {
      return !item.required;
    });
  };

  // 밑에 3개 useCheck 에서 뽑아서 사용
  const checkItem = (idx: number) => {
    // if (hasOnlyOptional()) {
    //   checkAll();
    //   return;
    // } else {
    setList((prev: any) => {
      const arr = [...prev];
      return arr.map((item, index) => {
        return {
          ...item,
          checked: index === idx ? !item.checked : item.checked,
        };
      });
    });
    // }
  };
  const checkAll = () => {
    setList((prev: any) => {
      const arr = [...prev];
      return arr.map((item) => {
        return {
          ...item,
          checked: !item.checked,
        };
      });
    });
  };
  const isActive = (() => {
    switch (activeCondition) {
      case 'all':
        return list.every((item: any) => item.checked);
      case 'essential':
      default:
        return list
          .filter((item: any) => item.required)
          .every((item: any) => item.checked);
    }
  })();

  return {
    isOpen,
    open,
    close,
    checkList: list,
    checkAll,
    checkItem,
    isActive,
  };
};

export default useCheckBottomsheet;
